class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $(".js-tab").each(function(){

      const $wrap = $(this);
      const $tabs = $wrap.find(".js-tab-item");
      const $contents = $wrap.find(".js-tab-content");
    
      $tabs.removeClass("is-active").first().addClass("is-active");
      $contents.hide().first().show();
    
      $tabs.on("click", function(){
    
        const index = $(this).index();
    
        $tabs.removeClass("is-active");
        $(this).addClass("is-active");
    
        $contents.hide().eq(index).show();
    
      });
    
    });

    gsap.registerPlugin(ScrollTrigger);

    const swipers = document.querySelectorAll('.js-parallax-swiper');
    const instances = [];
    swipers.forEach((el) => {
    
      const swiper = new Swiper(el, {
        loop: true,
        effect: "fade",
        speed: 1000,
        allowTouchMove: false,
      });
    
      instances.push(swiper);
    
    });
    
    let index = 0;
    
    setInterval(() => {    
      index++;
      instances.forEach((swiper, i) => {
        const total = swiper.slides.length - swiper.loopedSlides * 2;    
        const targetIndex = (index + i) % total;
        swiper.slideToLoop(targetIndex);
      });
    
    }, 3000);

    gsap.utils.toArray(".js-parallax-img").forEach((el) => {

      const imgs = el.querySelectorAll(".js-parallax-target");
    
      imgs.forEach((img) => {
        gsap.fromTo(
          img,
          {
            yPercent: -60
          },
          {
            yPercent: -40,
            ease: "none",
            scrollTrigger: {
              trigger: el,
              start: "top bottom",
              end: "bottom top",
              scrub: true
            }
          }
        );
      });
    
    });

    gsap.set([".p-top", ".js-header", ".js-fixed-nav"], {
      opacity: 0
    });
  
    const tl = gsap.timeline();
  
    tl.to({}, { duration: 1 }) // ← ローディングを見せる時間
  
    .to(".js-loading", {
      opacity: 0,
      duration: 0.6,
      ease: "power2.out",
      onComplete: () => {
        document.querySelector(".js-loading").classList.add("no-active");
      }
    })
    
    .to([".p-top", ".js-header", ".js-fixed-nav"], {
      opacity: 1,
      duration: 1,
      ease: "power2.out",
      stagger: 0.2,
      onComplete: () => {

        var mvSwiper = new Swiper(".js-mv-swiper", {
          slidesPerView: 1,
          effect: "fade",
          loop: true,
          speed: 2000,
          autoplay: {
            delay: 2000,
            disableOnInteraction: true
          },
        });
    
      }
    }, "-=0.3");

		// let modelhouseSwiper = null;
		// const breakpoint = 768;
	
		// function initSwiper() {
		// 	if ($(window).width() < breakpoint && modelhouseSwiper === null) {
	
		// 		modelhouseSwiper = new Swiper('.js-modelhouse-swiper', {
		// 			slidesPerView: 1.2,
		// 			centeredSlides: true,
		// 			spaceBetween: 10,
		// 			loop: true,
		// 		});
	
		// 	} else if ($(window).width() >= breakpoint && modelhouseSwiper !== null) {
	
		// 		modelhouseSwiper.destroy(true, true);
		// 		modelhouseSwiper = null;
	
		// 	}
		// }
	
		// initSwiper();
	
		// $(window).on('resize', function () {
		// 	initSwiper();
		// });

    let storySwiper;

    function initStorySwiper() {
    
      if (window.innerWidth < 768) {
    
        if (!storySwiper) {
          storySwiper = new Swiper(".js-story-swiper", {
            slidesPerView: 1.2,
            centeredSlides: true,
            loop: true,
            spaceBetween: 10,
            speed: 2000,
          });
        } 
      } else {
    
        if (storySwiper) {
          storySwiper.destroy(true, true);
          storySwiper = undefined;
        }
    
      }
    }
    
    // 🔥 ここ重要
    initStorySwiper();
    
    window.addEventListener("resize", initStorySwiper);
    
		// var mvSwiper = new Swiper(".js-mv-swiper", {
    //   slidesPerView: 1,
    //   effect: "fade",
    //   loop: true,
    //   speed: 1000,
    //   autoplay: {
    //     delay: 2000,
    //     disableOnInteraction: true
    //   },
    // });

		var worksSwiper = new Swiper(".js-works-swiper", {
      slidesPerView: "auto",
      loop: true,
      centeredSlides: true,
      spaceBetween: 10,
      speed: 1000,
      navigation: {
        nextEl: '.js-works-next',
        prevEl: '.js-works-prev',
      },
      pagination: {
        el: '.js-works-pagination',
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: "auto",
          spaceBetween: 11,
        }
      },
    });

		var modelhouseSwiper = new Swiper(".js-model-swiper", {
			slidesPerView: "auto",
      centeredSlides: true,
			spaceBetween: 10,
			loop: true,
      speed: 1000,
      // autoplay: {
      //   delay: 4000,
      //   disableOnInteraction: true
      // },
      breakpoints: {
        768: {
          slidesPerView: "auto",
          spaceBetween: 8,
        }
      },
      navigation: {
        nextEl: '.js-model-next',
        prevEl: '.js-model-prev',
      },
      pagination: {
        el: '.js-model-pagination',
        clickable: true,
      },
    });
	
    // var interviewSwiper = new Swiper(".js-swiper-interview", {
    //   slidesPerView: 1.4,
    //   centeredSlides: true,
    //   loop: true,
    //   spaceBetween: 16,
    //   speed: 1000,
    //   autoplay: {
    //     delay: 4000,
    //     disableOnInteraction: true
    //   },
    //   breakpoints: {
    //     768: {
    //       centeredSlides: false,
    //       slidesPerView: 3,
    //       spaceBetween: 40,
    //     }
    //   },
    //   pagination: {
    //     el: ".js-swiper-interview-pagination",
    //     clickable: true,
    //   },
    //   navigation: {
    //     nextEl: ".js-swiper-interview-next",
    //     prevEl: ".js-swiper-interview-prev",
    //   },
    // });

    // var loopSwiper = new Swiper(".-loop", {
    //   loop: true,
    //   slidesPerView: "auto",
    //   spaceBetween: 20,
    //   speed: 10000,
    //   allowTouchMove: false,
    //   autoplay: {
    //     delay: 0,
    //   },
    //   breakpoints: {
    //     768: {
    //       centeredSlides: false,
    //       slidesPerView: 3,
    //       spaceBetween: 20,
    //     }
    //   }
    // });

  }
}
